import React from 'react'
import type { BaseWeatherIconProps } from '../WeatherIcon'

const WeatherIconDayFunnelCloud: React.FC<BaseWeatherIconProps> = ({
  className = '',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      fill="none"
      className={className}
    >
      <path
        d="M35.9565 39.389C37.6565 35.3556 40.4454 31.9778 43.8676 29.4112C41.6342 25.1667 37.2342 22.2334 32.1009 22.2334C24.7342 22.2334 18.7676 28.2001 18.7676 35.5667C18.7676 39.7112 20.7009 43.3667 23.6676 45.8112C26.7565 42.3667 31.0787 40.0001 35.9565 39.389Z"
        fill="#F9D23E"
      />
      <path d="M34.0996 8.90002H30.0996V18.9H34.0996V8.90002Z" fill="#F9D23E" />
      <path
        d="M14.6589 15.299L11.8301 18.1274L18.9011 25.1994L21.7299 22.371L14.6589 15.299Z"
        fill="#F9D23E"
      />
      <path
        d="M15.4336 33.5667H5.43359V37.5667H15.4336V33.5667Z"
        fill="#F9D23E"
      />
      <path
        d="M49.5427 15.299L42.4727 22.371L45.3015 25.199L52.3715 18.127L49.5427 15.299Z"
        fill="#F9D23E"
      />
      <path
        d="M21.5784 48.6111L18.9007 45.9445L11.834 53.0111L14.6673 55.8445L21.2673 49.2333L21.734 48.7667L21.5784 48.6111Z"
        fill="#F9D23E"
      />
      <path
        d="M67.379 77.7667L62.5234 91.0889H67.2568L72.1012 77.7667H67.379Z"
        fill="#87D6F8"
      />
      <path
        d="M48.0232 77.7667L46.4121 82.2001H51.1454L52.7566 77.7667H48.0232Z"
        fill="#87D6F8"
      />
      <path
        d="M57.701 77.7667L56.0898 82.2001H60.8121L62.4232 77.7667H57.701Z"
        fill="#87D6F8"
      />
      <path
        d="M54.4666 86.6667L52.8555 91.1001H57.5888L59.1999 86.6667H54.4666Z"
        fill="#87D6F8"
      />
      <path
        d="M84.1671 53.5556H79.0893V48.6111C79.0893 37.7 69.9893 28.8556 58.7671 28.8556C53.5449 28.8556 48.856 30.8223 45.2782 33.9778C42.3782 36.5334 40.1893 39.8556 39.1782 43.6667H38.456C34.2227 43.6667 30.3893 45.3556 27.6338 48.0667C24.9115 50.7445 23.2227 54.4223 23.2227 58.4778C23.2227 66.6556 30.0449 73.2889 38.456 73.2889H43.5338H74.0115H84.1671C89.7782 73.2889 94.3227 68.8667 94.3227 63.4111C94.3227 57.9778 89.7782 53.5556 84.1671 53.5556Z"
        fill="#87D6F8"
      />
    </svg>
  )
}

export default WeatherIconDayFunnelCloud
